import { render } from "./AwardWinning.vue?vue&type=template&id=5d87d9c6&scoped=true"
import script from "./AwardWinning.vue?vue&type=script&lang=js"
export * from "./AwardWinning.vue?vue&type=script&lang=js"

import "./AwardWinning.vue?vue&type=style&index=0&id=5d87d9c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d87d9c6"]])

export default __exports__